import intl from 'react-intl-universal';

import { PortalInstance } from '@/components/PortalConfirm';
import { RentRecordInfo } from '@/redux/reducers/reservation/cancelReserve';
import { PriceChannel } from '@/config';

// 权限不足提示
export const showNoPermissionModal: (
  portal: PortalInstance,
  list: RentRecordInfo[],
) => Promise<boolean> = (portal, list) => {
  return new Promise((resolve) => {
    portal.showDrawer({
      title: intl.get('drawer_reserve_cancel_no_permission_title'),
      content: intl.get('drawer_reserve_cancel_no_permission_content', {
        channel: list?.some((item) => item.priceChannel === PriceChannel.DY_ZL) ? '抖音' : 'OTA',
      }),
      confirmText: intl.get('drawer_reserve_cancel_no_permission_confirm_btn'),
      onConfirm: () => {
        portal.closeDrawer();
        resolve(true);
      },
      onCancel: () => {
        portal.closeDrawer();
        resolve(false);
      },
    });
  });
};

// 直连渠道取消二次确认
export const showDirectCancelConfirm: (portal: PortalInstance) => Promise<boolean> = (portal) => {
  return new Promise((resolve) => {
    portal.showDrawer({
      title: intl.get('drawer_reserve_cancel_direct_confirm_title'),
      content: intl.get('drawer_reserve_cancel_direct_confirm_content'),
      cancelText: intl.get('drawer_reserve_cancel_direct_confirm_cancel_btn'),
      confirmText: intl.get('drawer_reserve_cancel_direct_confirm_submit_btn'),
      onConfirm: () => {
        portal.closeDrawer();
        resolve(true);
      },
      onCancel: () => {
        portal.closeDrawer();
        resolve(false);
      },
    });
  });
};
